import {
  get,
  post
}
from '../common/axiosHttp.js'

export const menuList = params => get("/menu/findTree", params);
